// src/hooks/useLogin.js

import { useAuth } from "../context/AuthContext";
import { jwtDecode } from "jwt-decode";

const JWT_KEY = "sso_jwt_token";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// جلب projectId من الـURL (مرة واحدة عند تحميل الملف)
const params = new URLSearchParams(window.location.search);
const projectId = params.get("projectId");

const useLogin = () => {
  const { loginWithJwt } = useAuth();

  // تسجيل الدخول
  const handleLogin = async (email, password) => {
    try {
      const bodyObj = {
        email,
        password,
      };
      if (projectId) {
        bodyObj.projectId = projectId;
      }

      const res = await fetch(`${API_BASE_URL}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyObj),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "فشل تسجيل الدخول");

      if (data.token) {
        loginWithJwt(data.token);
      } else {
        throw new Error("لم يتم استلام رمز الدخول (JWT)");
      }
    } catch (error) {
      throw error;
    }
  };

  // دالة جديدة: جلب رابط النسخة الأصلية بعد تسجيل الدخول (redirectUrl + jwt)
  const getRedirectUrlAfterLogin = async (userId) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/users/${userId}/activate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "فشل جلب رابط النسخة الأصلية");
      if (!data.redirectUrl)
        throw new Error("لم يتم العثور على رابط النسخة الأصلية");
      return data; // {redirectUrl, token, referralCode, ...}
    } catch (error) {
      throw error;
    }
  };

  // تسجيل مستخدم جديد
  const handleRegister = async (username, email, password, phoneNumber) => {
    try {
      const bodyObj = {
        name: username,
        email,
        password,
        role: "member",
        phoneNumber,
      };
      if (projectId) {
        bodyObj.projectId = projectId;
      }

      const res = await fetch(`${API_BASE_URL}/api/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyObj),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "فشل التسجيل");
      return data;
    } catch (error) {
      throw error;
    }
  };

  // استعادة كلمة المرور
  const handleForgotPassword = async (email) => {
    const res = await fetch(`${API_BASE_URL}/api/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "حدث خطأ أثناء إرسال رابط الاستعادة.");
    }

    return data;
  };

  // تسجيل الدخول باستخدام جوجل (غير مدعوم)
  const handleGoogleSignIn = async () => {
    throw new Error("تسجيل الدخول بجوجل غير مدعوم حالياً في فلو الـJWT.");
  };

  return {
    handleLogin,
    handleRegister,
    handleForgotPassword,
    handleGoogleSignIn,
    getRedirectUrlAfterLogin, // الدالة الجديدة
  };
};

export default useLogin;
